import React, { useRef, useState } from 'react';
import { ModeSettingEnum } from '@colonist/types';
import { arrow, autoUpdate, FloatingArrow, offset, useClick, useDismiss, useFloating, useInteractions } from '@floating-ui/react';
import IconRushInfo from '@static/images/icon_rushinfo.svg';
import { UIGameRushIntro } from '../../UIGameFeeds/UIGameRushIntro/UIGameRushIntro.tsx';
import { RUSH_INTRO_VISIBLE_FOR_FIRST_N_GAMES, RUSH_INTRO_AUTO_OPEN_FOR_FIRST_N_GAMES } from '../../UIGameFeeds/UIGameRushIntro/UIGameRushIntroConstants.ts';
import styles from './UIGameHelpRushIntroButton.module.scss';
import clsx from 'clsx';
import { useGameStore } from '../../../store/GameStoreContext.ts';
export const UIGameHelpRushIntroButton = ({ rushGamesPlayed, className })=>{
    const modeSetting = useGameStore((state)=>state.gameSettings.modeSetting);
    const isRushGame = modeSetting == ModeSettingEnum.ColonistRush4P;
    const isVisible = isRushGame && rushGamesPlayed < RUSH_INTRO_VISIBLE_FOR_FIRST_N_GAMES;
    const shouldAutoOpen = isRushGame && rushGamesPlayed < RUSH_INTRO_AUTO_OPEN_FOR_FIRST_N_GAMES;
    const [isOpen, setIsOpen] = useState(shouldAutoOpen);
    const arrowRef = useRef(null);
    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        placement: 'bottom-start',
        middleware: [
            offset(12),
            arrow({
                element: arrowRef
            })
        ],
        whileElementsMounted: autoUpdate
    });
    const click = useClick(context);
    const dismiss = useDismiss(context);
    const { getReferenceProps, getFloatingProps } = useInteractions([
        click,
        dismiss
    ]);
    if (!isVisible) return null;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("img", {
        className: clsx(styles.button, className),
        ref: refs.setReference,
        src: IconRushInfo,
        ...getReferenceProps()
    }), isOpen && /*#__PURE__*/ React.createElement("div", {
        ref: refs.setFloating,
        style: floatingStyles,
        ...getFloatingProps()
    }, /*#__PURE__*/ React.createElement(FloatingArrow, {
        className: styles.arrow,
        context: context,
        ref: arrowRef
    }), /*#__PURE__*/ React.createElement(UIGameRushIntro, {
        backgroundColor: "beige"
    })));
};
